import Vue from 'vue'

Vue.mixin({
  data: function () {
    return {
      GProd: 'Một sản phẩm của Nextpay'
    }
  }
})
